const s = _ref => {
  let {
    event: r,
    tabButtonRef: a,
    onSelectTab: n
  } = _ref;
  var f;
  if (!["ArrowLeft", "ArrowRight"].includes(r.key)) return;
  const c = (f = a.current) == null ? void 0 : f.parentElement,
    u = c.parentElement,
    e = c.childNodes,
    d = e[0],
    g = e[e.length - 1];
  e.forEach((v, l) => {
    if (e[l] === r.target) {
      if (r.key === "ArrowRight") {
        r.preventDefault();
        const i = e[l + 1],
          t = i || d,
          o = t.getBoundingClientRect().left;
        return u.scrollLeft = o, t.focus(), n == null ? void 0 : n(t.id);
      }
      if (r.key === "ArrowLeft") {
        r.preventDefault();
        const i = e[l - 1],
          t = i || g,
          o = t.getBoundingClientRect().left;
        return u.scrollLeft = o, t.focus(), n == null ? void 0 : n(t.id);
      }
    }
  });
};
export { s as handleKeyBoardNavigation };